//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import React from 'react';

import { Alert } from '@components/atoms/alert/Alert';
import { UiaProductTrackingIds } from '@uia/products/constants/UiaProductConstants';

export const ProductLoadingError = () => {
  return (
    <Alert
      trackingId={UiaProductTrackingIds.PRODUCT_EDITOR_ERROR_ALERT}
      type='error'
    >
      We had a problem loading your tracking parameters. Please try again later
      or contact Bazaarvoice support to edit this product tag URL.
    </Alert>
  );
};
